// Copyright (c) 2016 Deere & Company

import {isDaysToDisplayValid} from '../../shared/validations/days-to-display';

export const isClaimStatusValid = selectedStatuses => selectedStatuses.length > 0;

export const isClaimDaysToDisplayValid = days => isDaysToDisplayValid(days);

export const isFormValid = userClaimSettings =>
    isClaimStatusValid(userClaimSettings.status.selectedStatuses) &&
    isClaimDaysToDisplayValid(userClaimSettings.numberOfDays);



// WEBPACK FOOTER //
// ./src/user/claims-settings/services/form-validation.js